{
  "selectAsField": "เลือก \"{value}\" เป็น{fieldName}",
  "typeToSearchField": "พิมพ์เพื่อค้นหา{fieldName}",
  "licenseFieldLabel": "เลือกป้ายทะเบียน (เช่น 215BG2)",
  "licenseFieldName": "ป้ายทะเบียน",
  "licensePlaceholder": "ค้นหาตามป้ายทะเบียน",
  "dotFieldLabel": "เลือกหมายเลข DOT",
  "dotFieldName": "หมายเลข DOT",
  "dotPlaceholder": "ค้นหาตามหมายเลข DOT"
}
